<template>
  <div class="campaign-targeting">
    <utm v-if="selecting === 'utm'"
         :aid="aid"
         :startDate="startDate"
         :endDate="endDate"
         :utmCache="utm"
         :otherKeySet="false"
         @onSetUtm="onSetUtm($event)"
         @onCloseLayer="onCloseLayer" />
  </div>
</template>

<script>
import { EventBus } from '@/libs/event-bus'

import Utm from '@/components/report/campaign-targeting/Utm'

export default {
  name: 'CampaignTargeting',
  components: {
    Utm
  },
  props: ['aid', 'startDate', 'endDate', 'campaign', 'utmCache'],
  methods: {
    onSetUtm (utm) {
      if (utm) {
        for (let key of Object.keys(utm)) {
          if (utm[key] && utm[key].length < 1) {
            delete utm[key]
          }
        }
      }
      this.utm = utm
      this.selecting = false
    },
    onCloseLayer () {
      this.$emit('onClose')
      let campaignChanged = false
      let campaign = {
        utm: null
      }
      if (JSON.stringify(this.utm) !== JSON.stringify(this.campaign ? this.campaign.utm : null)) {
        campaignChanged = true
      }
      campaign.utm = this.utm
      if (!campaign.utm) {
        campaign = null
      }
      if (campaignChanged || !campaign) {
        EventBus.$emit('onCampaignChange', campaign, !campaign)
      }
    }
  },
  created () {
    this.utm = this.campaign ? this.campaign.utm : this.utmCache
  },
  computed: {
  },
  data () {
    return {
      selecting: 'utm',
      utm: null
    }
  }
}
</script>

<style lang="scss" scoped>
.campaign-targeting {
  .step {
    @include positionXYcenter;
    width: 731px;
    height: 526px;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
    overflow: hidden;
    background-color: #ffffff;
    border-radius: 15px;
    opacity: 1;

    .campaign-header {
      margin: 0 30px;
      border-bottom: 1px solid #bbbbbb;
      text-align: center;

      h2 {
        font-size: 20px;
        color: #444444;
        margin: 39px 0 15px;
      }

      p {
        font-size: 13px;
        line-height: 1.08;
        color: #888888;
        margin: 11px 0 30px;
      }
    }

    .campaign-body {
      margin: 0 30px;

      .campaign-selection {
        text-align: center;
        margin: 57px 0 5px;
        white-space: normal;

        button {
          position: relative;
          vertical-align: top;
          width: 172px;
          height: 172px;
          margin: 1px 10px;
          border: 2px solid #afafaf;
          border-radius: 13px;
          transition: border-color 0.2s ease,
          background-color 0.2s ease,
          box-shadow 0.2s ease;
          background-repeat: no-repeat;
          background-position: center calc(50% - 12px);

          &.disabled {
            opacity: 0.15;
            cursor: default;
          }

          &.utm {
            background-image: url(../../../assets/img/campaign-utm.svg);
          }

          .name {
            font-size: 16px;
            color: #444444;
            display: block;
            margin-top: 70px;
          }

          .count {
            .check {
              position: absolute;
              top: -1px;
              right: -1px;
              width: 19px;
              height: 19px;
              padding: 4px 4px 16px 16px;
              border-top-right-radius: 10px;
              background: url('../../../assets/img/campaign-button-bg.svg') transparent no-repeat right -30px top -30px;
              transition: background-position 0.15s ease;

              i {
                width: 16px;
                height: 16px;
              }
            }
          }

          i {
            width: 20px;
            height: 20px;
          }

          &.selected {
            border: 2px solid #3eaa08;
            background-color: rgba(62, 170, 8, 0.03);

            .count {
              .check {
                background-position: right 0 top 0;
              }
            }
          }

          &:hover:not(.disabled) {
            border: 2px solid #0274ff;
            background-color: #ffffff;
            box-shadow: 0 8px 12px -2px rgba(0, 0, 0, 0.25);

            .count {
              .check {
                background-position: right -30px top -30px;
              }
            }
          }
        }
      }

      .campaign-description {
        position: relative;
        margin-top: 43px;
        text-align: center;

        p {
          font-size: 13px;
          color: #ec0047;
          line-height: 1.38;
        }
      }
    }

    .campaign-footer {
      margin: 53px 0 20px;
      text-align: center;

      .ui-btn {
        width: 95px;
      }
    }
  }
}
</style>
